module.exports = "https://web-assets.ifttt.com/packs/media/onboarding_recommendations/applet_intro_small-93c27e7f.svg";